import {decorate, observable, action} from "mobx"

export class InsightsPopupStore {
  skipCacheForMOM = false
  skipCacheForMonthlyVisits = false
  skipCacheForBAA = false
  skipCacheForCrossoverBrands = false

  setSkipCacheForMOM(bool) {
    this.skipCacheForMOM = bool
  }

  setSkipCacheForMonthlyVisits(bool) {
    this.skipCacheForMonthlyVisits = bool
  }

  setSkipCacheForBAA(bool) {
    this.skipCacheForBAA = bool
  }

  setSkipCacheForCrossoverBrands(bool) {
    this.skipCacheForCrossoverBrands = bool
  }
}

decorate(InsightsPopupStore, {
  skipCacheForMOM: observable,
  setSkipCacheForMOM: action,

  skipCacheForMonthlyVisits: observable,
  setSkipCacheForMonthlyVisits: action,

  skipCacheForBAA: observable,
  setSkipCacheForBAA: action,

  skipCacheForCrossoverBrands: observable,
  setSkipCacheForCrossoverBrands: action,
})
